"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _typeof2 = _interopRequireDefault(require("babel-runtime/helpers/typeof"));
var _rule = _interopRequireDefault(require("../rule/"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function required(rule, value, callback, source, options) {
  var errors = [];
  var type = Array.isArray(value) ? 'array' : typeof value === 'undefined' ? 'undefined' : (0, _typeof2.default)(value);
  _rule.default.required(rule, value, source, errors, options, type);
  callback(errors);
}
var _default = required;
exports.default = _default;